// extracted by mini-css-extract-plugin
export var button = "_mg-2";
export var card = "_mg-0";
export var closeButtonContainer = "_mg-3";
export var iconContainer = "_mg-1";